import React from 'react';
import './confirm_registration_email_banner.scss';
import { useI18n } from 'hooks/use_i18n';
import { useSession } from 'hooks/use_context';
import get from 'lodash/get';
import isNil from 'lodash/isNil';

const ConfirmRegistrationEmailBanner = ({ children }) => {
  const { t } = useI18n();
  const { isProvider, isAnonymous, currentSellerAccount } = useSession();
  if (
    isNil(currentSellerAccount) ||
    isAnonymous ||
    isProvider ||
    get(currentSellerAccount, 'email_confirmed', false)
  ) {
    return children;
  }

  return (
    <div>
      <div
        className="confirm-email-banner bg-info"
        data-cy="confirm_email_banner"
      >
        <p className="mb-0 font-weight-bold">
          {t(
            'components.session.confirm_registration_email_banner.explanation',
          )}
        </p>
      </div>
      {children}
    </div>
  );
};

export default ConfirmRegistrationEmailBanner;
